import env from '../../env';
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const jwtHeaders = () => {
  const microsoftJWT = localStorage.getItem('microsoftJWT');
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(microsoftJWT ? { jwt: microsoftJWT } : {}),
  };
};

export const getAllRmas = createAsyncThunk('rmas/getAllRmas', async (arg = {}, { rejectWithValue }) => {
  const { criteria = 'number', searchValue = '', page = 1, pageSize = 50 } = arg;
  try {
    const { data } = await axios.get(
      `${env.API_URL}/rmas?filters[${criteria}][$containsi]=${encodeURIComponent(searchValue)}&sort=createdAt:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`,
      { headers: jwtHeaders() }
    );
    return data;
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }
});

export const getFilteredRmas = createAsyncThunk('rmas/getFilteredRmas', async (arg = {}, { rejectWithValue }) => {
  const { criteria = 'number', searchValue = '', page = 1, pageSize = 50 } = arg;
  try {
    const { data } = await axios.get(
      `${env.API_URL}/rmas?filters[${criteria}][$containsi]=${encodeURIComponent(searchValue)}&sort=createdAt:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`,
      { headers: jwtHeaders() }
    );
    return data;
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }
});

export const getRmaTracking = createAsyncThunk('rmas/getRmaTracking', async (arg, { rejectWithValue }) => {
  try {
    const { data } = await axios.get(`${env.API_URL_PREFIX}/findTracking/${arg}`, {
      headers: {
        jwt: localStorage.getItem('microsoftJWT'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }
});

export const getFilteredArticle = createAsyncThunk(
  'rmas/getFilteredArticle',
  async (arg = {}, { rejectWithValue }) => {
    const { criteria = 'serial', searchValue = '', page = 1, pageSize = 50 } = arg;
    try {
      const { data } = await axios.get(
        `${env.API_URL}/articles?filters[${criteria}][$containsi]=${encodeURIComponent(searchValue)}&populate[rma][populate]=debitor&sort=updatedAt:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize}`,
        { headers: jwtHeaders() }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  }
);
